import { AntDesign } from "@expo/vector-icons";
import { classValidatorResolver } from "@hookform/resolvers/class-validator";
import { BlurView } from "expo-blur";
import { router } from "expo-router";
import React from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Modal, View, Pressable, Text } from "react-native";
import { useDispatch } from "react-redux";

import Person from "@/assets/person.svg";
import Title from "@/components/Title";
import Button from "@/components/button/Button";
import Input from "@/components/input/Input";
import InputChoose from "@/components/input/InputChoose";
import InputDate from "@/components/input/InputDate";
import { setForm } from "@/context/actions/actions";
import { addIndividual } from "@/utils/dto/application.request";
import { IndividualIndividualType } from "@/utils/dto/extracted_enums";

interface IndividualModalProps {
  visible: boolean;
  onClick?: () => void;
  onClose: () => void;
}

interface FormData {
  individualType: string;
  percentageOwnership: string;
  relationshipEstablishedAt: string;
}

export default function IndividualModal(props: IndividualModalProps) {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const resolver = classValidatorResolver(addIndividual, {
    validator: { skipMissingProperties: true },
  });

  const { control, handleSubmit } = useForm<FormData>({
    mode: "onSubmit",
    resolver,
  });

  const onSubmit = async (data: FormData) => {
    const percentageConverted = Number(data.percentageOwnership);

    dispatch(
      setForm({
        individualType: data.individualType,
        relationshipEstablishedAt: data.relationshipEstablishedAt,
        percentageOwnership: percentageConverted,
        isAddIndividualFlow: true,
      })
    );
    props.onClose();
    router.push("/individual/name");
  };

  return (
    <Modal visible={props.visible} transparent animationType="fade">
      <BlurView intensity={20} className="flex-1 justify-center items-center">
        <View className="p-6 bg-white1 border border-gray rounded-lg w-full h-full items-center justify-center relative shadow lg:w-104 lg:h-168">
          <Pressable className="absolute right-3 top-3" onPress={props.onClose}>
            <AntDesign name="close" size={24} color="black" />
          </Pressable>
          <Person width={140} height={120} />
          <View className="m-2">
            <Title text={t("common:modal.individual.title")} />
          </View>
          <Text className="text-xs text-darkergray">
            {t("common:modal.individual.advice")}
          </Text>
          <View className="z-50 mt-4">
            <View className="z-50">
              <InputChoose
                label={t(
                  "onboarding/corporation/addindividual:input.individualtype"
                )}
                name="individualType"
                data={{ IndividualIndividualType }}
                control={control}
              />
            </View>
            <InputDate
              label={t(
                "onboarding/corporation/addindividual:input.relationshipestablishedat"
              )}
              control={control}
              name="relationshipEstablishedAt"
            />
            <Input
              label={t(
                "onboarding/corporation/addindividual:input.percentageownership"
              )}
              name="percentageOwnership"
              control={control}
              type="number"
            />
          </View>
          <Button
            label={t("common:button.nextstep")}
            onClick={handleSubmit(onSubmit)}
          />
        </View>
      </BlurView>
    </Modal>
  );
}
